import React, { useEffect, useState } from "react";
import { IsAlert } from "../component/atoms/IsAlert";
import { Link } from "react-router-dom";
import { fetchApi } from "../helper/api";
import { useParams } from "react-router-dom";
import ContentListIPC from "../component/organisms/ContentListIPC";
const $ = require('jquery')
$.Datatable = require('datatables.net')
const ListIPC = () => {
    const router = useParams()
    useEffect(() => {

    },[])
    return(
        <div className="p-4">
            <div className="d-flex align-items-center justify-content-between mb-4">
                <h1 className="mb-0">List IPC</h1>
            </div>
            <div className="box bg-white rounded-banget shadow p-4 table-responsive overflow-x-auto">
                <ContentListIPC id={router.id} />
            </div>
        </div>
    )
}
export default ListIPC